import { Injectable, NgZone, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Dictionary } from '@shared/types';
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics';
import { FirebasePerformance, PerformanceTrace, getPerformance, trace } from 'firebase/performance';
import { Firebase } from 'shared-ui/di/firebase';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private traces = new Map<string, PerformanceTrace>();
  private firebase = inject(Firebase);
  private platformId = inject(PLATFORM_ID);
  private ngZone = inject(NgZone);
  private analyticsClient: Analytics | null = null;
  private performanceClient: FirebasePerformance | null = null;

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      this.ngZone.runOutsideAngular(() => {
        this.analyticsClient = getAnalytics(this.firebase);
        this.performanceClient = getPerformance(this.firebase);
      });
    }
  }

  logEvent(name: string, params?: Dictionary) {
    if (!this.analyticsClient) return;
    try {
      logEvent(this.analyticsClient, name, params);
    } catch (error) {
      console.warn(error);
    }
  }

  createTrace(name: string) {
    if (!this.performanceClient) return null;
    return trace(this.performanceClient, name);
  }

  traceStart(name: string) {
    const t = this.createTrace(name);
    if (!t) return null;
    this.traces.set(name, t);
    t.start();
    return t;
  }

  traceStop(name: string) {
    const t = this.traces.get(name);
    try {
      t?.stop();
    } catch (error) {
      console.warn(error);
    }
    this.traces.delete(name);
    return t;
  }
}
